module.exports = __webpack_public_path__ + "static/media/ourteam.43e53883.png";